import * as React from "react";
import qs from "qs";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../store/hooks";
import { selectIsCplnTeam } from "../store/userSlice";

export const TriggerSentry: React.FC = () => {
  const isCplnTeam = useAppSelector(selectIsCplnTeam);
  const [message, setMessage] = React.useState<string | null>(null);

  React.useEffect(() => {
    const { message } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    setMessage((message || "Testing sentry") as string);
  }, []);

  if (!isCplnTeam) {
    return <Navigate to={`/`} />;
  }

  if (message === null) return null;

  throw new Error(message);
};
